export function runWithFPS(fn: (value: number) => void, fps: number) {
  const interval = 1000 / fps;
  let then = Date.now();
  let stopped = false;
  let animationFrame: number;

  function run() {
    if (!stopped) {
      animationFrame = requestAnimationFrame(run);
    }

    const now = Date.now();
    const delta = now - then;

    if (delta > interval && !stopped) {
      then = now - (delta % interval);
      fn(delta);
    }
  }

  animationFrame = requestAnimationFrame(run);
  fn(0);

  return function () {
    stopped = true;
    cancelAnimationFrame(animationFrame);
  };
}
